var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "text-primary" }, [
        _vm._v(" Aún no hay un repositorio creado ")
      ]),
      !_vm.isSuperAdmin
        ? _c("h5", { staticClass: "text-primary" }, [
            _vm._v(" Debe contactarse con su administrador ")
          ])
        : _vm._e(),
      _vm.isSuperAdmin
        ? _c(
            "vs-button",
            {
              staticClass: "mt-3",
              attrs: { "icon-after": "", color: "primary", icon: "add" },
              on: { click: _vm.openModal }
            },
            [_vm._v(" Crear repositorio ")]
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "newRepository",
          attrs: { title: "Crear repositorio", "hide-footer": "", centered: "" }
        },
        [
          _c("h5", [
            _vm._v("Esto creará el repositorio principal de la empresa.")
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 text-center" },
              [
                _c(
                  "vs-button",
                  {
                    staticClass: "mt-5 ml-3",
                    attrs: { color: "primary", disabled: _vm.loading },
                    on: { click: _vm.createRepository }
                  },
                  [
                    _vm._v(" Crear "),
                    _c("span", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      staticClass: "spinner-border spinner-border-sm text-white"
                    })
                  ]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }